const DAYS = [
	{ value: 2, label: 2 },
	{ value: 3, label: 3 },
  { value: 4, label: 4 },
  { value: 5, label: 5 },
  { value: 6, label: 6 }
];

export default DAYS;



// WEBPACK FOOTER //
// ./src/data/Days.js